import Highcharts from 'highcharts';

export const highchartDarkTheme = {
  colors: [
    '#018e98',
    'rgb(0, 184, 119)',
    '#DDDF0D',
    '#DF5353',
    '#aaeeee',
    '#ff0066',
    '#eeaaee',
    '#55BF3B',
    '#DF5353',
    '#7798BF',
    '#aaeeee',
  ],
  chart: {
    backgroundColor: '#3B3B3B',
    borderWidth: 0,
    borderRadius: 0,
    plotBackgroundColor: null,
    plotShadow: false,
    plotBorderWidth: 0,
  },
  title: {
    align: 'left',
    style: {
      color: '#FFFFFF',
      fontFamily: 'Nunito, sans serif',
      fontWeight: 700,
      fontSize: '1.2rem',
    },
  },
  subtitle: {
    style: {
      color: '#FFF',
      fontSize: '12px',
      fontFamily: 'Nunito, sans serif',
      fontWeight: 'bold',
    },
  },
  xAxis: {
    gridLineWidth: 0,
    lineColor: '#FFF',
    tickColor: '#FFF',
    labels: {
      style: {
        color: '#FFF',
        fontWeight: 'bold',
      },
    },
    title: {
      style: {
        color: '#FFF',
        fontSize: '12px',
        fontFamily: 'Nunito, sans serif',
        fontWeight: 'bold',
      },
    },
  },
  yAxis: {
    alternateGridColor: null,
    minorTickInterval: null,
    gridLineColor: '#F9F9F9',
    lineWidth: 0,
    tickWidth: 0,
    labels: {
      style: {
        color: '#FFF',
        fontWeight: 'bold',
      },
    },
    title: {
      style: {
        color: '#FFF',
        fontSize: '12px',
        fontFamily: 'Nunito, sans serif',
        fontWeight: 'bold',
      },
    },
  },
  legend: {
    itemStyle: {
      color: '#FFF',
    },
    itemHoverStyle: {
      color: '#FFF',
    },
    itemHiddenStyle: {
      color: '#FFF',
    },
  },
  credits: {
    style: {
      right: '50px',
    },
  },
  labels: {
    style: {
      color: '#FFF',
    },
  },
  tooltip: {
    backgroundColor: {
      linearGradient: [0, 0, 0, 50],
      stops: [
        [0, 'rgba(96, 96, 96, .8)'],
        [1, 'rgba(16, 16, 16, .8)'],
      ],
    },
    borderWidth: 0,
    style: {
      color: '#FFF',
    },
  },

  plotOptions: {
    line: {
      dataLabels: {
        color: '#FFF',
      },
      marker: {
        lineColor: '#FFF',
      },
    },
    spline: {
      marker: {
        lineColor: '#FFF',
      },
    },
    scatter: {
      marker: {
        lineColor: '#FFF',
      },
    },
    series: {
      animation: 0,
    },
  },

  toolbar: {
    itemStyle: {
      color: '#FFF',
    },
  },
  spacing: [15, 15, 15, 15],
};

export const highchartLightTheme = {
  colors: [
    '#7cb5ec',
    '#0B606B',
    '#9B9B09',
    '#f7a35c',
    '#8085e9',
    '#f15c80',
    '#e4d354',
    '#2b908f',
    '#f45b5b',
    '#91e8e1',
  ],
  chart: {
    backgroundColor: '#ffffff',
    borderWidth: 0,
    borderRadius: 0,
    plotBackgroundColor: null,
    plotShadow: false,
    plotBorderWidth: 0,
  },
  title: {
    align: 'left',
    style: {
      color: 'black',
      fontFamily: 'Nunito, sans serif',
      fontWeight: 700,
      fontSize: '1.2rem',
    },
  },
  subtitle: {
    style: {
      color: 'black',
      fontSize: '12px',
      fontFamily: 'Nunito, sans serif',
      fontWeight: 'bold',
    },
  },
  xAxis: {
    gridLineWidth: 1,
    lineColor: '#C6C6C6',
    tickColor: '#000',
    labels: {
      style: {
        color: '#000',
        fontWeight: 'bold',
      },
    },
    title: {
      style: {
        color: '#000',
        fontSize: '12px',
        fontFamily: 'Nunito, sans serif',
        fontWeight: 'bold',
      },
    },
  },
  yAxis: {
    alternateGridColor: null,
    minorTickInterval: null,
    gridLineColor: '#C6C6C6',
    lineWidth: 0,
    tickWidth: 0,
    labels: {
      style: {
        color: '#000',
        fontWeight: 'bold',
      },
    },
    title: {
      style: {
        color: '#000',
        fontSize: '12px',
        fontFamily: 'Nunito, sans serif',
        fontWeight: 'bold',
      },
    },
  },
  legend: {
    itemStyle: {
      color: '#000',
    },
    itemHoverStyle: {
      color: '#FFF',
    },
    itemHiddenStyle: {
      color: '#333',
    },
  },
  credits: {
    style: {
      right: '50px',
    },
  },
  labels: {
    style: {
      color: '#CCC',
    },
  },
  tooltip: {
    backgroundColor: {
      linearGradient: [0, 0, 0, 50],
      stops: [
        [0, 'rgba(96, 96, 96, .8)'],
        [1, 'rgba(16, 16, 16, .8)'],
      ],
    },
    borderWidth: 0,
    style: {
      color: '#FFF',
    },
  },

  plotOptions: {
    line: {
      dataLabels: {
        color: '#CCC',
      },
      marker: {
        lineColor: '#333',
      },
    },
    spline: {
      marker: {
        lineColor: '#333',
      },
    },
    scatter: {
      marker: {
        lineColor: '#333',
      },
    },
    series: {
      animation: 0,
    },
  },

  toolbar: {
    itemStyle: {
      color: '#CCC',
    },
  },
  spacing: [15, 15, 15, 15],
};

export const chartToggle = (input) => {
  switch (input) {
    case false:
      Highcharts.setOptions(highchartLightTheme);
      break;
    case true:
      Highcharts.setOptions(highchartDarkTheme);
  }
};
